import './bluefiredragon/style';
import FormStructure from './bluefiredragon/form_structure';

export default FormStructure;